import { render, staticRenderFns } from "./UnmatchedCardIcon.vue?vue&type=template&id=12719f0f&scoped=true&"
import script from "./UnmatchedCardIcon.vue?vue&type=script&lang=js&"
export * from "./UnmatchedCardIcon.vue?vue&type=script&lang=js&"
import style0 from "./UnmatchedCardIcon.vue?vue&type=style&index=0&id=12719f0f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12719f0f",
  null
  
)

export default component.exports